import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import HTMLReactParser from "html-react-parser"
import React from "react"

import { mainCatgeory } from "../../utils/post"

export function Post({ post, locale }) {
  return (
    <div className="flex flex-col overflow-hidden border-2 border-transparent rounded-lg shadow-lg group hover:border-blue-200 hover:ring-1 hover:ring-blue-200">
      <div className="flex-shrink-0 overflow-hidden">
        {post?.featuredImage && (
          <GatsbyImage
            className="object-cover w-full h-48 transition-all group-hover:scale-125 group-hover:rotate-1"
            image={
              post.featuredImage.node.localFile.childImageSharp.gatsbyImageData
            }
            alt={post.featuredImage.node.altText}
          />
        )}
      </div>
      <div className="flex flex-col justify-between flex-1 p-6 bg-white">
        <div className="flex-1">
          {post?.categories?.nodes?.length > 0 && (
            <p className="text-sm font-bold font-medium text-blue-400">
              <span className="">{mainCatgeory(post).name}</span>
            </p>
          )}
          <Link to={post.uri} className="block mt-2">
            <p className="text-xl font-semibold text-gray-900">{post.title}</p>
            <p className="mt-3 text-base text-gray-500">
              {post.excerpt && HTMLReactParser(post.excerpt)}
            </p>
          </Link>
        </div>
        <div className="flex items-center mt-6">
          <div className="flex-shrink-0">
            {/* <a href={post.author.uri}>
                <span className="sr-only">{post.author.name}</span>
                <img
                  className="w-10 h-10 rounded-full"
                  src={post.author.imageUrl}
                  alt=""
                />
              </a> */}
          </div>
          <div className="">
            {/* <p className="text-sm font-medium text-gray-900">
                <a
                  href={post.author.href}
                  className="hover:underline"
                >
                  {post.author.name}
                </a>
              </p> */}
            <div className="flex space-x-1 text-sm text-gray-500">
              <time className="capitalize" dateTime={post.datetime}>
                {post[`dateSticker_${locale.slice(0, 2)}`]}
              </time>
              {post.readingTime && (
                <span aria-hidden="true">&middot; {post.readingTime}</span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Post
